<template lang="html">
  <div>
    <h1>Promos for encrypted link</h1>
    <hr />
    <v-layout align-start class="py-2">
      <v-text-field solo label="Promo" @input="onInput" v-model="newPromo.original"></v-text-field>
      <div>
        <v-btn style="margin-top: 6px; margin-left: 6px;" @click="create" color="success">Create</v-btn>
      </div>
    </v-layout>
    <v-layout row align-start class="py-2">
      <v-data-table v-if="promos" :headers="[
        { text: 'ID', value: 'id' },
        { text: 'PROMO', value: 'original' },
        { text: 'ENCODED', value: 'promo' },
        { text: 'ACTION', value: 'delete' },
        { text: 'ACTION', value: 'copy' },
      ]" :items="promos" class="pb-4">
        <template v-slot:item.delete="{ item }">
          <v-btn text @click="del(item.id)" color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.copy="{ item }">
          <v-btn text @click="copy(item.promo)" color="success">COPY LINK</v-btn>
        </template>
      </v-data-table>
    </v-layout>
  </div>
</template>
  
<script>
import { encodeURL } from 'js-base64';

export default {
  name: "playlist",
  data() {
    return {
      promos: null,
      newPromo: {
        original: null,
        promo: null
      }
    }
  },
  methods: {
    sync() {
      axios.get('/encoded', {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        this.promos = res.data.data;
      });
    },
    async del(id) {
      await axios.post('/encoded/delete', { id: id }).then(res => {
        this.sync();
      });
    },
    onInput(e) {
      let elem = e;
      this.newPromo.original = elem;
      this.newPromo.promo = encodeURIComponent(elem);
    },
    async create() {
      await axios.post('/encoded/create', { data: this.newPromo }).then(res => {
        this.sync();
      });

      this.newPromo.original = null;
      this.newPromo.promo = null;
    },
    copy(e) {
      let elem = e.replace(' ', '%20');
      let link = 'https://playlist-game.app/#/main?presentCode='+elem;
      // Copy the text inside the text field
      navigator.clipboard.writeText(link)
        .then(function() {
          alert("URL copied to clipboard!");
        })
        .catch(function(error) {
          console.error("Error copying URL to clipboard:", error);
        });
    }
  },
  created() {
    this.sync();
  }
};
</script>
  
<style lang="scss" scoped>
.style-one {
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

.pagination {
  display: inline-block;
  padding-left: 0;
  margin: -10px 5px !important;
  border-radius: 4px;
}
</style>
  